import { getEmailTrendsService, getClickTrendsService } from 'modules/Services/AnalyticsService';
import { ANALYTICS_DATA_EXPORT, ANALYTICS_EMAIL_TRENDS, ANALYTICS_INTENT_DATA, ANALYTICS_CLICK_TRENDS } from 'constants/types';
import store from 'store';

export const getEmailTrends = (params: any) => {
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  return getEmailTrendsService(params)
    .then((data) => {
      if (params.exportAnalytics) {
        store.dispatch({
          type: ANALYTICS_DATA_EXPORT.SET_OPEN,
          payload: data.data.email_address,
        });
      } else {
        store.dispatch({
          type: ANALYTICS_EMAIL_TRENDS.LOAD_SUCCESS,
          payload: data.data,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: ANALYTICS_EMAIL_TRENDS.LOAD_FAIL,
      });
    });
};

export const getClickTrends = (params: any) => {
  if (!params.exportAnalytics)
    store.dispatch({
      type: ANALYTICS_CLICK_TRENDS.LOAD,
    });

  return getClickTrendsService(params)
    .then((response) => {
      if (params.exportAnalytics) {
        store.dispatch({
          type: ANALYTICS_DATA_EXPORT.SET_OPEN,
          payload: response.data.email_address,
        });
      } else {
        store.dispatch({
          type: ANALYTICS_CLICK_TRENDS.LOAD_SUCCESS,
          payload: response.data,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: ANALYTICS_CLICK_TRENDS.LOAD_FAIL,
      });
    });
};
